
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Asnières-sur-Seine dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Asnières-sur-Seine certifiée Google Partner, accompagne les entreprises asniéroises pour booster leur visibilité et conquérir de nouveaux clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Asnières-sur-Seine dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Asnières-sur-Seine certifiée Google Partner, accompagne les entreprises asniéroises pour booster leur visibilité et conquérir de nouveaux clients.",
        },
      ],
    };
  },
};
